import _toConsumableArray from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.now.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.unescape.js";
import "core-js/modules/web.btoa.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { defineComponent } from "vue";
// const axios = require("axios");

export default defineComponent({
  name: "VoiceController",
  components: {},
  setup: function setup() {
    return {};
  },
  mounted: function mounted() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  } // mounted
  ,
  watch: {
    "$store.state.speakToProcess": "TTS"
  },
  props: {},
  data: function data() {
    return {
      // lastSentences: [],
    };
  },
  methods: {
    getCloudAudioFromString: function getCloudAudioFromString(message) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var qs;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              qs = require("qs");
              return _context3.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(resolve) {
                  var userToken, dataToSet, data, config, response, buffer, blob;
                  return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        userToken = localStorage.getItem("security");
                        dataToSet = {
                          token: userToken,
                          sentence: message,
                          avatar: _this.$store.state.avatar,
                          voiceCode: _this.$store.state.customerSelectedVoice || null
                        };
                        data = qs.stringify(dataToSet);
                        config = {
                          method: "post",
                          url: "".concat(_this.$store.state.systemRoute, "/").concat(_this.$store.state.featureEnabledTextToSpeech ? 'getVoiceToUsePro' : 'getVoiceToUse'),
                          headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                            Accept: "audio/wav"
                          },
                          responseType: "arraybuffer",
                          data: data
                        };
                        console.log('trying to get cloud audio');
                        _context2.prev = 5;
                        _context2.next = 8;
                        return _this.axios(config);
                      case 8:
                        response = _context2.sent;
                        buffer = response.data;
                        blob = new Blob([buffer], {
                          type: "audio/wav"
                        });
                        resolve(blob);
                        _context2.next = 18;
                        break;
                      case 14:
                        _context2.prev = 14;
                        _context2.t0 = _context2["catch"](5);
                        console.error("Error in getCloudAudioFromString", _context2.t0);
                        resolve('no cloud audio');
                      case 18:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2, null, [[5, 14]]);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }()));
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getSingleAnimation: function getSingleAnimation(text) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", new Promise(function (resolve, reject) {
                // replace all ' with nothing
                // text = text.replace(/'/g, "");
                // // replace all " with nothing
                // text = text.replace(/"/g, "");
                // text = text.replace(/./g, "");
                var axios = require("axios");
                var qs = require("qs");
                var data = qs.stringify({
                  text: text
                });
                var config = {
                  method: "post",
                  maxBodyLength: Infinity,
                  url: "".concat(_this2.$store.state.systemRoute, "/singleTextToSpeech"),
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                  },
                  data: data
                };
                axios.request(config).then(function (response) {
                  var animations = [];
                  var animationResults = response.data.animations;
                  if (animationResults.length > 0) {
                    for (var i = 0; i < animationResults.length; i++) {
                      animations = [].concat(_toConsumableArray(animations), _toConsumableArray(animationResults[i]));
                    }
                  } else {
                    animations.push(animations);
                  }
                  resolve(animations);
                })["catch"](function (error) {
                  console.error(error);
                  reject();
                });
              }));
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    // methods
    TTS: function TTS() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var sentence;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!(_this3.$store.state.speakToProcess.length < 0)) {
                _context6.next = 2;
                break;
              }
              return _context6.abrupt("return");
            case 2:
              sentence = _this3.$store.state.speakToProcess;
              /*********ON DEVICE TALK*********/
              return _context6.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(resolve) {
                  var animations, audioBlob, utf8Encoded, sentenceBase64, last8Characters, index, payload;
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.next = 2;
                        return _this3.getSingleAnimation(sentence);
                      case 2:
                        animations = _context5.sent;
                        // this.$store.commit("updateFloatingText", "");
                        audioBlob = undefined;
                        if (!(!_this3.$store.state.onDeviceTextToSpeech || _this3.$store.state.onDeviceTextToSpeech === "false")) {
                          _context5.next = 8;
                          break;
                        }
                        _context5.next = 7;
                        return _this3.getCloudAudioFromString(sentence);
                      case 7:
                        audioBlob = _context5.sent;
                      case 8:
                        // base64 of sentence
                        utf8Encoded = unescape(encodeURIComponent(sentence));
                        sentenceBase64 = btoa(JSON.stringify(utf8Encoded));
                        last8Characters = sentenceBase64.slice(-8);
                        index = 0;
                        try {
                          index = _this3.$store.state.queueIndexMapping[last8Characters];
                        } catch (e) {
                          console.error("no mapping for this message queue");
                        }
                        payload = {
                          sentence: sentence.trim(),
                          animations: animations,
                          index: index
                        };
                        if (audioBlob) {
                          payload.audioBlob = audioBlob;
                        }
                        _this3.$store.commit('updateActivityLogs', '<br /><br />Adding sentence: ' + sentence);
                        if (_this3.$store.state.onDeviceTextToSpeech) {
                          _this3.$store.commit("updateQueuedOnDeviceTTSSentences", sentence);
                          _this3.$store.commit("updateQueuedOnDeviceTTSAnimations", animations);
                        } else {
                          _this3.$store.commit("updateQueuedCloudTTSSentences", payload);
                          _this3.$store.commit("updateQueuedCloudTTSAnimations", payload);
                        }
                        // this.animationsToBePlayed = [...getSingleAnimationResults];
                        resolve();
                      case 18:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }()));
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    playQueuedTTS: function playQueuedTTS() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var sentences, animations, ttsObject, singleSentence, singleAnimation, audioBlob, synth, utterance;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this4.$store.commit('updateActivityLogs', 'playingQueuedTTS');
              if (_this4.$store.state.queuedTTSPlaying) {
                _context7.next = 61;
                break;
              }
              _this4.$store.commit('updateActivityLogs', 'queuedTTSPlaying is false, trying to play');
              //used for cloud tts
              if (_this4.$store.state.onDeviceTextToSpeech) {
                sentences = _toConsumableArray(_this4.$store.state.queuedOnDeviceTTSSentences);
                animations = _toConsumableArray(_this4.$store.state.queuedOnDeviceTTSAnimations);
                _this4.$store.commit("removeSingleQueuedOnDeviceTTS");
              } else {
                //these are not really sentences or animations just used for code simplifcation
                sentences = _toConsumableArray(_this4.$store.state.queuedCloudAudioMetadata);
                animations = _toConsumableArray(_this4.$store.state.queuedCloudAudioMetadata);
                ttsObject = _toConsumableArray(_this4.$store.state.queuedCloudAudioMetadata);
                _this4.$store.commit("removeSingleQueuedCloudAudioMetadata");
              }
              if (!(sentences.length > 0)) {
                _context7.next = 53;
                break;
              }
              console.log('we have some sentences');
              _this4.$store.commit('updateActivityLogs', 'queuedTTSPlaying we have sentences');

              //if something is not currently playing then play the next sentence
              if (_this4.$store.state.queuedTTSPlaying) {
                _context7.next = 48;
                break;
              }
              _this4.$store.commit("updateQueuedTTSPlaying", true);
              if (_this4.$store.state.onDeviceTextToSpeech) {
                _this4.$store.commit("updateIsTalking", true);
                singleSentence = sentences[0];
                // this.$store.commit("updateLastSentences", singleSentence);
                singleAnimation = animations[0];
                // remove the first sentence from the array to prepare for the next incoming queued
              } else {
                singleSentence = ttsObject[0].sentence;
                singleAnimation = ttsObject[0].animation;
                audioBlob = ttsObject[0].audioBlob;
                // remove the first sentence from the array to prepare for the next incoming queued
              }
              if (!_this4.$store.state.useAudio) {
                _context7.next = 42;
                break;
              }
              _this4.$store.commit('updateActivityLogs', 'queuedTTSPlaying indicates we are using audio');

              // on device tts speaking
              if (!_this4.$store.state.onDeviceTextToSpeech) {
                _context7.next = 27;
                break;
              }
              _this4.$store.commit('updateActivityLogs', 'onDeviceTextToSpeech happening');
              synth = window.speechSynthesis;
              _this4.$store.commit("updateFrameCurrent", 0);
              _this4.$store.commit("addAvatarSound", singleAnimation);
              _this4.$store.commit("updateFloatingTextAI", singleSentence);
              _context7.next = 20;
              return _this4.$store.dispatch("updateOnDeviceVoice");
            case 20:
              utterance = new SpeechSynthesisUtterance(singleSentence);
              utterance.voice = _this4.$store.state.selectedAvatarVoice;
              synth.speak(utterance);
              // wait for the sentence to finish
              _context7.next = 25;
              return new Promise(function (resolve) {
                utterance.onend = function () {
                  resolve();
                };
              });
            case 25:
              _context7.next = 40;
              break;
            case 27:
              _this4.$store.commit('updateActivityLogs', 'cloudTTS happening');
              // cloud voice tts speaking
              _this4.$store.commit("updateFrameCurrent", 0);
              _this4.$store.commit("addAvatarSound", singleAnimation);
              _this4.$store.commit("updateFloatingTextAI", singleSentence);
              // await this.audioCreate(audioBlob);
              _context7.prev = 31;
              _context7.next = 34;
              return _this4.audioPlay(audioBlob);
            case 34:
              _context7.next = 40;
              break;
            case 36:
              _context7.prev = 36;
              _context7.t0 = _context7["catch"](31);
              _this4.$store.commit('updateActivityLogsError', 'error in audioPlay', JSON.stringify(_context7.t0));
              console.error('error in audioPlay', _context7.t0);
            case 40:
              _context7.next = 43;
              break;
            case 42:
              _this4.$store.commit('updateActivityLogs', 'queuedTTSPlaying NO AUDIO FLAG!');
            case 43:
              console.log(">>>>>> finishing sentence ", singleSentence);
              _this4.$store.commit("updateFloatingTextAI", "");
              // free up the queue hold to play the next one now
              _this4.$store.commit("updateQueuedTTSPlaying", false);
              _context7.next = 50;
              break;
            case 48:
              _context7.next = 50;
              return new Promise(function (resolve) {
                setTimeout(function () {
                  resolve();
                }, 1000);
              });
            case 50:
              _this4.playQueuedTTS();
              _context7.next = 59;
              break;
            case 53:
              console.log('no sentences to play');
              _this4.$store.commit('updateActivityLogs', 'queuedTTSPlaying no sentences');
              _this4.$store.commit('updateActivityLogs', JSON.stringify(sentences));
              _this4.$store.commit("clearQueuedCloudTTS");
              _this4.$store.commit("updateaiTalking", false);
              _this4.$store.commit('updateResetMouthDefaults', true);
              // this.resetMouthDefaults();
            case 59:
              _context7.next = 63;
              break;
            case 61:
              setTimeout(function () {
                _this4.playQueuedTTS();
              }, 1000);
              _this4.$store.commit('updateActivityLogs', 'queuedTTSPlaying is true, no action yet');
            case 63:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[31, 36]]);
      }))();
    },
    processCloudTTSPayloads: function processCloudTTSPayloads() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var startTime;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this5.$store.commit('updateActivityLogs', '<br /><br />processCloudTTSPayloads');
              if (!_this5.$store.state.processingCloudTTSPayloads) {
                _this5.$store.commit("updateProcessingCloudTTSPayloads", true);
                startTime = Date.now();
                _this5.prepAudioCloudTTS(startTime);
              }
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    prepAudioCloudTTS: function prepAudioCloudTTS(startTime) {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var sentences, animations, currentProcessingIndex, currentTime, timeDifference, singleSentence, singleAnimation, audioBlob;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this6.$store.commit('updateActivityLogs', '<br /><br />prepAudioCloudTTS');

              // stick incoming sentences into array with audio blob for queue
              sentences = _this6.$store.state.queuedCloudTTSSentences;
              animations = _this6.$store.state.queuedCloudTTSAnimations;
              currentProcessingIndex = _this6.$store.state.queueCloudTTSProcessingCounter;
              currentTime = Date.now();
              timeDifference = currentTime - startTime; // if more than 10 seconds have passed, stop processing
              if (!(timeDifference > 10000)) {
                _context9.next = 9;
                break;
              }
              _this6.$store.commit("updateProcessingCloudTTSPayloads", false);
              return _context9.abrupt("return");
            case 9:
              if (!(sentences[currentProcessingIndex] === null || !sentences[currentProcessingIndex])) {
                _context9.next = 14;
                break;
              }
              setTimeout(function () {
                _this6.prepAudioCloudTTS(startTime);
              }, 200);
              return _context9.abrupt("return");
            case 14:
              singleSentence = sentences[currentProcessingIndex].sentence;
              singleAnimation = animations[currentProcessingIndex].animations;
              audioBlob = sentences[currentProcessingIndex].audioBlob;
              _this6.$store.commit("updateQueueCloudTTSProcessingCounter");
              _this6.$store.commit('updateActivityLogs', '<br /><br />adding to cloudAudioMetadata ' + singleSentence);
              _this6.$store.commit("updateQueuedCloudAudioMetadata", {
                audioBlob: audioBlob,
                sentence: singleSentence,
                animation: singleAnimation
              });

              // refresh timestamp
              currentTime = Date.now();

              // check for more
              _this6.prepAudioCloudTTS(currentTime);

              //if nothing is already playing send it to be played
              if (!_this6.$store.state.queuedTTSPlaying) {
                _this6.playQueuedTTS();
              } else {
                // if something is already playing, wait 1 second and try again
                setTimeout(function () {
                  _this6.playQueuedTTS();
                }, 2000);
              }
            case 23:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    audioPlay: function audioPlay(audioBlob) {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              return _context11.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(resolve) {
                  var audio, waitTimeMS;
                  return _regeneratorRuntime().wrap(function _callee10$(_context10) {
                    while (1) switch (_context10.prev = _context10.next) {
                      case 0:
                        _this7.$store.commit('updateActivityLogs', 'Playing audio');
                        try {
                          audio = new Audio(URL.createObjectURL(audioBlob));
                          audio.setAttribute('playsinline', 'true');
                          waitTimeMS = 0;
                          audio.onloadedmetadata = function () {
                            var duration = audio.duration;
                            waitTimeMS = duration * 1000;
                            audio.play();
                            setTimeout(function () {
                              resolve();
                            }, waitTimeMS + 500);
                          };
                          // get audio duration from blob
                        } catch (error) {
                          _this7.$store.commit('updateActivityLogsError', 'Error in audioPlay' + JSON.stringify(error));
                          console.error("error in audioPlay", error);
                        }
                      case 2:
                      case "end":
                        return _context10.stop();
                    }
                  }, _callee10);
                }));
                return function (_x3) {
                  return _ref3.apply(this, arguments);
                };
              }()));
            case 1:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    verifyNotDate: function verifyNotDate(sentence) {
      var _this8 = this;
      return new Promise( /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(resolve) {
          var dateCheck;
          return _regeneratorRuntime().wrap(function _callee12$(_context12) {
            while (1) switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return _this8.extractAndCheckDateString(sentence);
              case 2:
                dateCheck = _context12.sent;
                if (!dateCheck.found) {
                  _context12.next = 9;
                  break;
                }
                if (!dateCheck.isEmpty) {
                  _context12.next = 8;
                  break;
                }
                return _context12.abrupt("return", resolve());
              case 8:
                sentence = dateCheck.updatedString;
              case 9:
                resolve(sentence);
              case 10:
              case "end":
                return _context12.stop();
            }
          }, _callee12);
        }));
        return function (_x4) {
          return _ref4.apply(this, arguments);
        };
      }());
    },
    extractAndCheckDateString: function extractAndCheckDateString(inputString) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt("return", new Promise(function (resolve) {
                // Define the regex pattern to match the desired date format
                var regexPattern = /\(([^)]+)\)/;

                // Use the regex pattern to search for the date pattern within the input string
                var match = inputString.match(regexPattern);
                if (match) {
                  // Extract the matched date string
                  var dateString = match[0];

                  // Remove the matched date string from the input
                  var updatedString = inputString.replace(regexPattern, "").trim();

                  // Check if the updated string is empty or contains only whitespace
                  var isEmptyString = /^\s*$/.test(updatedString);
                  resolve({
                    found: true,
                    dateString: dateString,
                    isEmpty: isEmptyString,
                    updatedString: isEmptyString ? "" : updatedString
                  });
                } else {
                  resolve({
                    found: false,
                    dateString: null,
                    isEmpty: /^\s*$/.test(inputString),
                    updatedString: inputString
                  });
                }
              }));
            case 1:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    }
  }
});